import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { TaskBoard } from '@progress/kendo-react-taskboard';
import { Card as UserCard } from '../components/UserCard';
import config from '../config/config';
import { createGlobalStyle } from 'styled-components';

/* ------------------------------------------------------------------ */
/* Globale Styles – Toolbar-Buttons im TaskBoard ausblenden           */
/* ------------------------------------------------------------------ */
const GlobalStyle = createGlobalStyle`
  .employee-assignment-modal {
    .k-taskboard-column-header-actions,
    .k-taskboard-card-actions,
    .k-taskboard-card svg[aria-hidden="true"] {
      display: none !important;
    }
  }
`;

/* ------------------------------------------------------------------ */
/* Modal für Mitarbeiterzuweisung                                     */
/* ------------------------------------------------------------------ */
const EmployeeAssignmentModal = ({
  visible,
  onClose,
  jobID,
  initialAssignedEmployees,
  users,
  showNotification
}) => {
  /* Spalten-Definition für das TaskBoard */
  const columns = React.useMemo(
    () => [
      { id: 1, title: 'Mitarbeiter', status: 'employee' },
      { id: 2, title: 'Zugewiesene Mitarbeiter', status: 'assigned' }
    ],
    []
  );

  const [taskBoardData, setTaskBoardData] = React.useState([]);

  /* -------------------------------------------------------------- */
  /* Users alphabetisch sortieren  →  TaskBoard-Daten aufbauen      */
  /* -------------------------------------------------------------- */
  React.useEffect(() => {
    if (!users || users.length === 0) return;

    /* A-Z sortiert nach label */
    const sorted = [...users].sort((a, b) =>
      a.label.localeCompare(b.label, 'de', { sensitivity: 'base' })
    );

    const assigned = initialAssignedEmployees || [];

    const tasks = sorted.map((u) => ({
      id: u.value,
      title: u.label,
      status: assigned.includes(u.value) ? 'assigned' : 'employee',
      avatarThumbLink: u.avatarThumbLink,
      priority: { color: 'gray', priority: 'None' }
    }));

    setTaskBoardData(tasks);
  }, [users, initialAssignedEmployees]);

  /* -------------------------------------------------------------- */
  const onTaskBoardChange = (e) => {
    if (e.type !== 'column') setTaskBoardData(e.data);
  };

  /* Speichern-Handler: in DB sichern und neue Liste zurückgeben   */
  const handleSave = async () => {
    const assigned = taskBoardData
      .filter((t) => t.status === 'assigned')
      .map((t) => t.id);

    try {
      await fetch(`${config.host}/jobs/${jobID}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ AssignedEmployee: assigned })
      });

      showNotification('success', 'Mitarbeiterzuweisung gespeichert ✓');
      onClose(assigned); // ⇦ neue Liste an Parent zurückgeben
    } catch (err) {
      console.error('Error saving assigned employees:', err);
      showNotification('error', 'Speichern fehlgeschlagen.');
    }
  };

  /* Nur schließen, keine Daten zurückgeben                        */
  const handleCancel = () => onClose();

  /* -------------------------------------------------------------- */
  if (!visible) return null;

  return (
    <>
      <GlobalStyle />
      <Dialog
        title="Mitarbeiter zuweisen"
        onClose={handleCancel}
        width={730}
        className="employee-assignment-modal"
      >
        <div style={{ padding: 20 }}>
          <TaskBoard
            columnData={columns}
            taskData={taskBoardData}
            onChange={onTaskBoardChange}
            card={UserCard}
            style={{ height: 400 }}
          />

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 10,
              marginTop: 20
            }}
          >
            <Button onClick={handleCancel}>Abbrechen</Button>
            <Button themeColor="primary" onClick={handleSave}>
              Speichern
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default EmployeeAssignmentModal;